export default __webpack_public_path__ + "static/media/Labirynth-01.2bc8ed3b.svg";